import { ProjectGroupMetaInformation } from '../interfaces/project-group-meta-information';

/**
 * Liefert die Beschriftung einer Position anhand der Metainformationen.
 * Gibt den gepflegten Text (description) zurück, sonst den Standardtext "Position {x}".
 * y = 1 entspricht Bereich A, y = 2 entspricht Bereich B (identisch zum Schema-Tab).
 */
export function getMetaInformationLabel(
  metaInformation: ProjectGroupMetaInformation[] | undefined,
  x: number,
  y: number
): string {
  const meta = metaInformation?.find(info => info.x === x && info.y === y);
  return meta?.description ? meta.description : 'Position ' + x;
}

/**
 * Liefert die gepflegte Beschreibung (description) einer Position anhand der
 * Metainformationen oder undefined, wenn keine gepflegt ist (kein Fallback).
 * Für Anzeigen, die bei fehlender Metainformation nichts darstellen sollen.
 */
export function findMetaInformationDescription(
  metaInformation: ProjectGroupMetaInformation[] | undefined,
  x: number,
  y: number
): string | undefined {
  return metaInformation?.find(info => info.x === x && info.y === y)?.description || undefined;
}
